/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
1.0 Variables etc.
2.0 Universal styles
3.0 Header
    3.1 Quote Popout
4.0 Pages
    4.1 Homepage
    4.2 Platforms
    4.3 About
    4.4 Get a Quote
5.0 Collections
    5.1 Work
6.0 Products / Portfolio Items
7.0 Footer
8.0 Cart
9.0 Blogs
    9.1 Careers

/*--------------------------------------------------------------
1.0 Variables, etc.
--------------------------------------------------------------*/

/*--------------------------------------------------------------
2.0 Universal Styles
--------------------------------------------------------------*/

/* For all form submissions */
window.addEventListener('load', function(){
    const formNote = document.querySelector('.form-note');
    if(formNote){
        const overlay = document.querySelector('.overlay');
        if(overlay) {
            overlay.style.display = 'block';
        }
        
        setTimeout(function() {
            formNote.style.transition = 'opacity 0.4s ease-in-out';
            formNote.style.opacity = '1';
            formNote.style.display = 'block';
        }, 500);
        
        const closeElements = document.querySelectorAll('.closeDialog, .overlay');
        closeElements.forEach(function(element) {
            element.addEventListener('click', function(){
                if(overlay) {
                    overlay.style.transition = 'opacity 0.4s ease-in-out';
                    overlay.style.opacity = '0';
                    setTimeout(function() {
                        overlay.style.display = 'none';
                    }, 400);
                }
                formNote.style.transition = 'opacity 0.4s ease-in-out';
                formNote.style.opacity = '0';
                setTimeout(function() {
                    formNote.style.display = 'none';
                }, 400);
            });
        });
    }
});

/* Add user's IP address to hidden IP field of forms */
document.addEventListener('DOMContentLoaded', function() {
    const userIpField = document.querySelector('.contact-form #user-ip');
    if(userIpField) {
        fetch('https://extreme-ip-lookup.com/json/')
            .then(response => response.json())
            .then(data => {
                const userIp = data.query;
                userIpField.value = userIp;
            })
            .catch(error => {
                console.warn('Could not fetch IP address:', error);
            });
    }
});

/* Smooth scroll to sections on-page */
document.addEventListener("DOMContentLoaded", function() {
    // Select all anchor links that start with a hash
    const links = document.querySelectorAll('a[href^="#"]');
    
    // Add an event listener to each link
    links.forEach(function(link) {
      const href = link.getAttribute("href");
  
      // Skip any hrefs containing "#modal_"
      if (href.includes("#modal_")) return;
  
      link.addEventListener("click", function(e) {
        // Prevent the default action (jumping to the anchor)
        e.preventDefault();
  
        // Get the target element from the hash in the link's href
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
  
        if (targetElement) {
          // Scroll to the target element smoothly
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        } else {
          console.warn("Target element not found for ID: " + targetId);
        }
      });
    });
  });
  
  
  

/*--------------------------------------------------------------
3.0 Header
--------------------------------------------------------------*/

// Mobile Menu -- Remove all checkbox "checked" states on page load
window.addEventListener('load', function() {
    // Get all checkbox inputs on the page
    const checkboxes = document.querySelectorAll('header.sb-main .mobile-menu-container input[type="checkbox"]');
    
    // Loop through each checkbox and set it to unchecked
    checkboxes.forEach(function(checkbox) {
      checkbox.checked = false;
    });
});

// Nav Bar Global Behavior
function checkHeader() {
    const header = document.getElementById('shopify-section-header'); // Get header by ID
    
    // Select all target elements for the first and second cases
    const firstTargetElements = document.querySelectorAll('[data-header-color="dark-text"]');
    const secondTargetElements = document.querySelectorAll('[data-header-color="default"]'); // Select "default" class
    
    let isFirstInView = false; // Flag to track if any first target element has reached the top of the page
    let isSecondInView = false; // Flag to track if any second target element has reached the top of the page
    
    let headerBackground = ''; // Variable to store the background style to apply to the header
    
    // Check if any first target elements (dark-text) are in view
    firstTargetElements.forEach(targetElement => {
        const targetPosition = targetElement.getBoundingClientRect().top;

        // If the target element's top reaches or is above the top of the viewport
        if (targetPosition <= 60 && targetPosition >= -targetElement.offsetHeight) {
            isFirstInView = true; // Set flag if first target has reached the top
            // Extract background attribute (now using 'data-header-background')
            headerBackground = targetElement.getAttribute('data-header-background') || ''; 
        }
    });

    // Check if any second target elements (default) are in view
    secondTargetElements.forEach(targetElement => {
        const targetPosition = targetElement.getBoundingClientRect().top;

        // If the target element's top reaches or is above the top of the viewport
        if (targetPosition <= 60 && targetPosition >= -targetElement.offsetHeight) {
            isSecondInView = true; // Set flag if second target has reached the top
            // Extract background attribute (now using 'data-header-background')
            headerBackground = targetElement.getAttribute('data-header-background') || '';
        }
    });

    // Apply the appropriate class based on which target element is in view
    if (isFirstInView) {
        header.classList.add('dark-text'); // Apply dark-text class if any first target has reached the top
        header.classList.remove('default'); // Remove default class if any first target has reached the top
    } else if (isSecondInView) {
        header.classList.add('default'); // Apply default class if any second target has reached the top
        header.classList.remove('dark-text'); // Remove dark-text class if any second target has reached the top
    } else {
        header.classList.remove('dark-text', 'default'); // Remove both classes if neither target has reached the top
    }

    // Apply the extracted background style to the header (if available)
    if (headerBackground) {
        header.style.backgroundColor = headerBackground; // Apply background color from 'data-header-background'
    }
}

window.addEventListener('scroll', checkHeader); // Listen for scroll events
checkHeader(); // Check on page load

/*--------------------------------------------------------------
4.2 Platforms
--------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
    if (document.body.classList.contains("template-services")) {
        const anchor = window.location.hash;
        if (anchor) {
            setTimeout(() => {
                const targetElement = document.querySelector(anchor);
                if (targetElement) {
                    // Get the vertical position of the element
                    const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;

                    // Scroll to 100px above the element
                    window.scrollTo({
                        top: elementTop - 100,
                        behavior: "smooth"
                    });

                    // Find and check a checkbox inside the target element
                    const checkbox = targetElement.querySelector('input.services-input[type="radio"]');
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                }
            }, 100);
        }
    }
});

/*--------------------------------------------------------------
5.1 Work
--------------------------------------------------------------*/

function sortBy(value) {
    const url = new URL(window.location.href);

    // Update or add the sort_by parameter
    url.searchParams.set('sort_by', value);

    // Update the URL without reloading the page
    window.location.href = url.toString();
}

function removeSort() {
    window.location.href = window.location.href.replace(window.location.search, '');
}
/*--------------------------------------------------------------
6.0 Products / Portfolio Items
--------------------------------------------------------------*/
if(document.body.classList.contains('template-product')) {
    // Get all the navigation links and sections
    const navLinks = document.querySelectorAll('.portfolio-title-bar a');
    const sections = document.querySelectorAll('h3');

    // Function to check if the section is in the viewport
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top <= window.innerHeight && // The section is 100px away from the top of the viewport
            rect.bottom >= 0 && // Ensure the section is still visible
            rect.left >= 0 &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Function to update the active class on the navigation links
    function updateActiveLink() {
        navLinks.forEach(link => {
            // Remove active class from all links
            link.classList.remove('active');

            // Get the section ID from the href attribute of the link
            const targetId = link.getAttribute('href').substring(1); // Remove '#' from href

            // Find the section with the matching ID
            const targetSection = document.getElementById(targetId);

            // Add the 'active' class to the link if its section is in the viewport
            if (targetSection && isInViewport(targetSection)) {
                link.classList.add('active');
            }
        });
    }

    // Listen for the scroll event
    window.addEventListener('scroll', updateActiveLink);

    // Initial call to highlight the active link when the page loads
    updateActiveLink();
}